module.exports = __webpack_public_path__ + "static/media/appoptics-logo-simple.ab4b4127.svg";